module.exports = __webpack_public_path__ + "static/media/advertisement.3b8146cf.svg";